import Fetch from "@/utils/Fetch"

export default {
	namespaced: true,
	state() {
		return {
			storeGroups: null,
			stores: null
		}
	},
	mutations: {
		setStoreGroups(state,storeGroups) {
			state.storeGroups = storeGroups
		},
		setStores(state,stores) {
			state.stores = stores
		},
	},
	actions: {
		async requestStoreGroups({commit, dispatch}, filter) {
			commit('startLoading', 'requestStoreGroups', {root: true})


			const searchUrl = new URL('/', 'http://nahodka.localhost/')

			Object.entries(filter).forEach(([key, value]) => {
				searchUrl.searchParams.append(key, String(value))
			})

			const response = await Fetch(`shop-groups/${searchUrl.search}`, {
				method: 'GET',
			});

			if (response.success) {
				commit('setStoreGroups', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestStoreGroups', {root: true})

			return {
				...response.data
			}
		},
		async requestStores({commit, dispatch}) {
			commit('startLoading', 'requestStores', {root: true})

			const response = await Fetch('shops/', {
				method: 'GET'
			})

			if (response.success) {
				commit('setStores', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestStores', {root: true})

			return {
				...response.data
			}

		}
	},

	getters: {
		getStoreGroups: state => state.storeGroups,
		getStores: state => state.stores,
	}
}

